import MerchantOnboardingLocationHoursPage from '../../../../components/merchant/onboarding-location-hours/MerchantOnboardingLocationHoursPage'

export default function LocationHours() {
  return <MerchantOnboardingLocationHoursPage />
}
